module.exports = __webpack_public_path__ + "static/media/shohrukh.1eace853.png";